import * as React from 'react'
import type { SVGProps } from 'react'
const SvgDribbble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1C5.9243 1 1 5.9253 1 12s4.9243 11 11 11 11-4.9252 11-11S18.0757 1 12 1m9.0613 10.4876c-2.3605-.3868-4.5311-.4079-6.5111-.0669a39 39 0 0 0-.7031-1.54c2.1175-.9167 3.8179-2.1615 5.0857-3.7419a9.04 9.04 0 0 1 2.1285 5.3488m-3.5219-6.6752c-1.1046 1.4245-2.629 2.5511-4.5705 3.3734a42.4 42.4 0 0 0-3.1973-4.9849A9.07 9.07 0 0 1 12 2.9131c2.0854 0 4.004.714 5.5394 1.8993m-9.6396-.9102a40.9 40.9 0 0 1 3.2422 4.9325c-2.2275.6555-4.8867.9919-7.9603 1.013a9.103 9.103 0 0 1 4.718-5.9455M2.913 12l.0119-.2347c3.5283-.0045 6.5716-.4106 9.1208-1.2118.2136.4354.418.8727.6142 1.3127-3.0983.9689-5.6512 2.9535-7.6422 5.94A9.043 9.043 0 0 1 2.913 12m3.5099 7.1592c1.805-2.8307 4.1085-4.6732 6.9648-5.5248a35.88 35.88 0 0 1 1.8728 6.8384c-3.0699 1.1834-6.3736.6104-8.8376-1.3136m10.6205.3941a37.66 37.66 0 0 0-1.76-6.3222c1.7197-.2429 3.6117-.1797 5.6824.1796a9.097 9.097 0 0 1-3.9224 6.1426"
    />
  </svg>
)
export default SvgDribbble
